import {isActiveTour} from '../three/tour.js'
const dialogBaseUrl = 'getDialog/';

export function getDialog( container, controlElement, id, mouseEvent = null, centered = false ) {
    let inDemoTour = isActiveTour();
    if (inDemoTour) {
        centered = true;
    }
    let dialogId = $( '#' + id );
    let url = dialogBaseUrl + ( id.includes( "fixed" ) ? "fixed-dialogs." : "draggable-dialogs." ) + id;
    if ( dialogId.length === 0 ) {
        $.ajax( {
            url: url,
            async: false,
            success: function ( data ) {
                hideAllDialogs();
                $( container ).append( data );
                dialogId = $( '#' + id ); //Neu setzen der Dialog ID war vorher leer
                setDialogPosition( container, controlElement, dialogId, mouseEvent, centered );
                if ( !centered || inDemoTour) {
                    makeDialogDraggable( $( '.build-element-dialog' ) );
                }
                dialogId.find( '.custom-select' ).select2( {
                    dropdownCssClass: ':all:',
                    selectionCssClass: ':all:',
                    minimumResultsForSearch: Infinity
                } );
            },
            error: function ( data ) {
                console.log( data );
            }
        } );
    } else {
        let wasVisible = dialogId.is( ":visible" ); //Prüfen, ob der Dialog vorher sichtbar war um nachher die richtige Sichtbarkeit einzustellen
        hideAllDialogs();
        if ( !wasVisible ) {
            dialogId.show();
        }
        setDialogPosition( container, controlElement, dialogId, mouseEvent, centered );
        if ( !centered ) {
            makeDialogDraggable( $( '.build-element-dialog' ) );
        }
    }
    return dialogId;
}

function hideAllDialogs() {
    $( '.build-element-fixed-dialog' ).hide();
    $( '.build-element-dialog' ).hide();
}

function setDialogPosition( container, controlElement, dialog, mouseEvent, centered ) {
    if ( !centered ) {
        if ( mouseEvent !== null ) {
            dialog.css( { 'top': mouseEvent.clientY + "px", 'left': mouseEvent.clientX + "px" } );
        }

        let scenesRect = container.getBoundingClientRect();
        let dialogRect = document.getElementById( dialog.attr( 'id' ) ).getBoundingClientRect();

        let diff = dialogRect.right - scenesRect.right + 10;
        if ( dialogRect.right + 10 >= scenesRect.right ) {
            let leftPosition = parseFloat( dialog.css( "left" ).replace( "px", "" ) ) - diff;
            dialog.css( "left", leftPosition );
        }
    } else {
        if (dialog.attr('id')=='tutorials-fixed-dialog') {
            dialog.css( { 'position': 'absolute', 'left': '50%', 'top': '50%', 'transform': 'translate(-50%,-50%)' } );
        } else {
            dialog.css( { 'position': 'absolute', 'left': '37%', 'top': '20%'} );
        }
    }
}

export function makeDialogDraggable( dialog ) {
    dialog.draggable( { containment: "parent", handle: '.dialog-header-bar' } );
}
